import React from 'react';

import CustomBlock from 'uicontainers/apps/survey/CustomBlock';

const Fraud = () => {
  return <CustomBlock />;
};

export default Fraud;
